// KundenstreckeParentForm.jsx
import React, { useState, useEffect } from 'react';
import Form1 from './KundenstreckeForm1';
import Form2 from './KundenstreckeForm2';
import Form3 from './KundenstreckeForm3';
import Form4 from './KundenstreckeForm4';
import Form5 from './KundenstreckeForm5';
import Form6 from './KundenstreckeForm6';
import Form7 from './KundenstreckeFormSuccess';
import LoadingOverlay from '../../custom_elements/LoadingOverlay'; // The component for the loading overlay

import { Login, isLoggedIn } from '../Login';
import ChatBox from '../../custom_elements/ChatBox';
import { ContinueButton, BackButton, SendButton } from '../../custom_elements/ContinueButton';
import Product from '../../custom_elements/Product';
import axios from 'axios';
import ConfettiExplosion from 'react-confetti-explosion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faPlus, faShareAlt, faShareAltSquare } from '@fortawesome/free-solid-svg-icons';
import { useValidation } from '../../custom_elements/ValidationContext';

export default function KundenstreckeParentForm() {
    const [form, setForm] = useState(1);
    const [newForm, setNewForm] = useState(form);
    const [fade, setFade] = useState(true); // Control fade animation
    const [loggedIn, setLoggedIn] = useState(false);
    
    const [loading, setLoading] = useState(false);  // State to manage loading

    const [getFormDataFromChild, passGetFormDataFromChild] = useState(null);
    const [getValidateAllFormFieldsFromChild, passValidateAllFormFieldsFromChild] = useState(null);
    const [formData, setFormData] = useState(null);

    const [isExploding, setIsExploding] = React.useState(false);
    const [chosenProduct, setChosenProduct] = useState(null);
    const [shownChats, setShownChats] = useState([]);
    const [zweck, setZweck] = useState(null);
    const [userid, setUserid] = useState(localStorage.getItem('userid') || -1);
    const [user_token, setUserToken] = useState(localStorage.getItem('user_token') || -1);
    const { validateAllFields } = useValidation();
    
    const backendUrl = process.env.REACT_APP_DOMAIN_BACKEND; // Get domain from environment variable

    const nextForm = () => {
        setLoading(true);  // Start loading animation
console.log("!!! userid: "+userid);
//console.log("in nextForm, form now: "+form);
        window.scrollTo(0, 0);
        setNewForm(form + 1);
        if ((form !== 5) && (form !== 4)) {
            localStorage.setItem('form', form + 1);
        }
        setLoading(false);  // Stop loading animation
    };
    const prevForm = () => setNewForm(form - 1);

    const forms = { "1": Form1, "2": Form2, "3": Form3, "4": Form4, "5": Form5, "6": Form6, "7": Form7 };

    const navButtons = Object.keys(forms).map((key) => (
        <div
            key={key}
            className={`navButton ${form === parseInt(key) ? 'active' : parseInt(localStorage.getItem('form')) >= parseInt(key) ? 'previous' : ''}`}
            onClick={localStorage.getItem('form') < parseInt(key) ? null : () => setNewForm(parseInt(key))}
            style={{
                backgroundColor: form === parseInt(key) ? '#e72d28' : parseInt(localStorage.getItem('form')) >= parseInt(key) ? 'gray' : '',
                color: form === parseInt(key) ? 'white' : parseInt(localStorage.getItem('form')) >= parseInt(key) ? 'white' : '',
                border: form === parseInt(key) ? 'none' : parseInt(localStorage.getItem('form')) >= parseInt(key) ? 'none' : '',
                cursor: parseInt(localStorage.getItem('form')) >= parseInt(key) ? 'pointer' : 'default'
            }}
        >
            {parseInt(key) != 6 ? key : <FontAwesomeIcon
                size=""
                icon={faPaperPlane}
              />}
        </div>
    ));

    const getFormDataFromDB = () => {
        //console.log("INSIDE getFormDataFromDB on ParentForm");
        //console.log("USERID " + userid);
        setUserid(userid);
        fetch(`${backendUrl}/ajaxController.php?action=getFormData`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({'benutzer_id': userid, 'user_token': user_token, 'form_no': form}) // Assuming you need to send some data to the backend
        })
            .then(response => response.json())
            .then(data => {
                // Handle the response from the backend
                console.log(data);
                //console.log('Form data retrieved successfully');
                if (data.error) {
        console.log("error: " + data.error_text);
                    alert(data.error_text);
                }
                else {
                    console.log(forms[newForm]);

                    let mergedData = { ...data };
                    try {
                        const local = localStorage.getItem('anfangsFormData');
                        if (local) {
                            const localData = JSON.parse(local);
                            // Merge - prefer backend values if they exist
                            for (const [key, value] of Object.entries(localData)) {
                                if (
                                    mergedData[key] === null ||
                                    mergedData[key] === undefined ||
                                    mergedData[key] === "" ||
                                    mergedData[key] === "0"
                                ) {
                                    if(key == 'kaufpreis') {
                                        mergedData['k_erwerb'] = value;
                                    }
                                    else if(key == 'eigenmittel') {
                                        mergedData['em'] = value;
                                    }
                                    else {
                                        mergedData[key] = value;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        console.error("Error merging with localStorage data: ", err);
                    }

                    setFormData(mergedData);
                    console.log("Final merged formData: ");
                    console.log(mergedData);

                    if (data.benutzer_id) {
            console.log("data.benutzer_id " + data.benutzer_id);
                        setUserid(data.benutzer_id);
                        setUserToken(data.user_token);
                        localStorage.setItem('userid', data.benutzer_id);
                        localStorage.setItem('user_token', data.user_token);
                    }
                }
            })
            .catch(error => {
                // Handle any errors
                console.error(error);
            });
        return 0;
    }

    const handleLogin = () => {
        setLoggedIn(isLoggedIn());
    };

    const updateChat = (chat) => {
        console.log("IN updateChat!");
        const uniqueId = Date.now(); // Generate a unique ID based on timestamp
        const newChat = { id: uniqueId, message: chat }; // Add the unique ID to the chat object

        setShownChats([newChat]); // Add the new chat message
    };

    useEffect(() => {
        console.log("in useEffect");
        getFormDataFromDB();
        const old_userid = localStorage.getItem('userid');
        const old_user_token = localStorage.getItem('user_token');
        if (old_userid) {
            setUserid(old_userid);
        }
        if (old_user_token) {
            setUserToken(old_user_token);
        }
        
    }, []);

    useEffect(() => {
        if (newForm !== form) {
            setShownChats([]);
            setFade(false); // Trigger fade-out
            setTimeout(() => {
            getFormDataFromDB();
            setForm(newForm); // Change form after fade-out
            setFade(true); // Trigger fade-in after change
          }, 200); // Match the timeout to your fade-out duration
        }
        if(newForm === 5) {
            fetchProductData();
        }
      }, [newForm]);

    const saveProductData = (product) => {
        console.log("IN HERE PRODUCt wooo")
        console.log(product);
        setChosenProduct(product);
    }

    const sendFormData = (action, bValidateForm = true) => {
        console.log("IN sendFormData ParentForm")

        console.log("calling getValidateAllFormFieldsFromChild in ParentForm")

        if (bValidateForm) {
            if ( getValidateAllFormFieldsFromChild() ) {
                console.log("valid");
            }
            else {
                console.log("invalid");
                return 0;
            }
            //console.log(getValidateAllFormFieldsFromChild())
            //return 0;
        }
        setLoading(true);  // Start loading animation

	    if (bValidateForm && (document.getElementsByClassName('error-message').length != 0)) {
            setLoading(false);  // Stop loading animationa
		    alert("Bitte füllen Sie alle Felder korrekt aus!");
	    } else {
            console.log("IN sendFormData ParentForm calling getFormDataFromChild")
            const formDataFromChild = getFormDataFromChild(); // Assuming each form component has a method called getFormData() that returns the form data in JSON format

            console.log("getFormDataFromChild in ParentForm: ");
            console.log(formDataFromChild);

            console.log("IN sendFormData ParentForm calling getFormDataFromChild END");
            formDataFromChild.benutzer_id = userid;
            formDataFromChild.user_token = user_token;
            formDataFromChild.chosen_product = chosenProduct;
            formDataFromChild.form_no = form;

            const referrer_id = localStorage.getItem('referrerId');
            formDataFromChild.referrer_id = "";
            if (referrer_id) {
                formDataFromChild.referrer_id = referrer_id;
            }

            if (bValidateForm) {
                // Make a call to your backend API to send the formData
                // Example code using fetch:
                fetch(`${backendUrl}/ajaxController.php?action=saveFormData`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formDataFromChild)
                })
                .then(response => response.json())
                .then(data => {
                    // Handle the response from the backend
                    console.log(data);
                    if (data && data.success) {
                        // Show a success message to the user
                        console.log('Form data saved successfully');
                        action();
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                    if ((form !== 6)) {
                        setLoading(false);  // Stop loading animation
                    }
                })
                .catch(error => {
                    setLoading(false);  // Stop loading animation
                    // Handle any errors
                    console.error(error);
                });
	        }
            else {
                //go to previous form without checking and saving
                action();
                setLoading(false);  // Stop loading animation
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
	    }
        return 0;
    };

    const sendEinreichungMail = () => {
        setLoading(true);  // Start loading animation
        fetch(`${backendUrl}/ajaxController.php?action=sendEinreichungMail`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({'benutzer_id': localStorage.getItem('userid'), 'user_token': localStorage.getItem('user_token')}) // Assuming you need to send some data to the backend
        })      
        .then(response => response.json())
        .then(data => {
            // Handle the response from the backend
            console.log(data);
            if (data && data.success) {
                // Show a success message to the user
                nextForm();
                console.log('sendEinreichungMail successfull');
            }
            setLoading(false);  // Stop loading animation
        })
        .catch(error => {
            setLoading(false);  // Stop loading animation
            // Handle any errors
            console.error(error);
        });
    };

    const [passedRequestDataState, setPassedRequestDataState] = useState({'benutzer_id': localStorage.getItem('userid'), 'user_token': localStorage.getItem('user_token')});
    const [products, setProducts] = useState([]);
    const [callDone, setCallDone] = useState(false);
    const [callSuccess, setCallSuccess] = useState(false);

    const fetchProductData = async () => {
    setLoading(true);  // Start loading animation
    setIsExploding(false);
    setProducts([]);
    try {
        const apiUrl = `${backendUrl}/ajaxController.php?action=getFoProdukte`;

        const response = await axios.post(apiUrl, {
            benutzer_id: userid,
            user_token: user_token
        });

        console.log("response");
        console.log(JSON.parse(response.data));
        if (response.data && Array.isArray(JSON.parse(response.data).products)) {
            setCallSuccess(true);
            cleanProducts(JSON.parse(response.data).products);
            setIsExploding(true);
            setLoading(false);  // Stop loading animation
        } else {
            setLoading(false);  // Stop loading animation
        }
    } catch (error) {
        setLoading(false);  // Stop loading animation

        console.error('Error fetching data:', error);
    }
    setCallDone(true);
    };

    const handleFormChange = (value) => {
        setZweck(value); // Update form state
      };

    const cleanProducts = (products) => {
        const cleanedProducts = products.map((product) => {
            return {
                kreditbetrag: parseFloat(product.KREDITBETRAG),
                rate: parseFloat(product.RATE),
                laufzeit: product.LAUFZEIT,
                sollzins: parseFloat(product.ZINS),
                fixlaufzeit: product.FIXLAUFZEIT,
                institut: product.BANK,
                description: product.TITLE,
                bag: parseFloat(product.BAG),
                grundbuch: parseFloat(product.GRUNDBUCH),
                bank_id: parseInt(product.BANK_ID),
                result_id: parseInt(product.fin_result_id_local),
            };
        });
        console.log("cleanedProducts")
        console.log(cleanedProducts)
        setProducts(cleanedProducts);
    };

    return (
        <>
            {!loggedIn ? (
                <>
                    <div className="mainContainer">
                    {/* Loading Overlay */}
                    {loading && <LoadingOverlay message=" " />}

                    {isExploding && <ConfettiExplosion duration={3000} style={{left: "40%", top: "200px"}} z-index={5000} particleCount={200} particleSize={8} width={1500}/>}
                        <div className="upperRow">
                            <div className="emptyContainer"></div>
                            <div className="finleyContainer">
                                <img className="finley-img" id="finley" src={process.env.PUBLIC_URL + '/finley.png'} />
                                <ChatBox timer_value={0}>
                                    Hi!<br />
                                    Mein Name ist FINley - ich begleite dich auf dem Weg zu Deinem individualisierten Finanzierungsangebot!
                                    <br class="chat-text-right"/><br class="chat-text-right"/>
                                    <a href="#hilfe" class="chat-text-right chat-text-right-a">mehr Hilfe &rarr;</a>
                                </ChatBox>
                            </div>
                        </div>
                        <div className="lowerRow">
                            <div className="formBox">
                                <div className="navRow">
                                    {navButtons}
                                </div>
                                <div className={`fade-wrapper ${fade ? 'fade-in' : 'fade-out'}`} style={{marginBottom: "15px"}}>
                                    {Object.keys(forms).map((key) => (
                                        (form == parseInt(key) && React.createElement(forms[key], { nextForm, passGetFormData: passGetFormDataFromChild, passValidateAllFormFields: passValidateAllFormFieldsFromChild, sendChat: updateChat, retrievedFormData: formData, products: products, callDone: callDone}))
                                    ))}
                                </div>
                                {form < 5 &&
                                <div className="navRow button-row">
                                    <ContinueButton onClick={() => sendFormData(nextForm)} />
                                    {form > 1 && <BackButton onClick={() => sendFormData(prevForm, false)} />}
                                </div>}
                                {form == 5 &&
                                    <div className='fo-product-list'>
                                    {callSuccess &&
                                        products.map((product, index) => (
                                            <Product product={product} onAngebotButtonClick={() => {saveProductData(product); nextForm();}}/>
                                        ))}
                                    </div>
                                }
                                {form == 6 &&
                                <>
                                    <Product product={chosenProduct} style={{marginTop: "15px"}} onAngebotButtonClick={() => {nextForm();}} isContactForm={true}/>
                                    <div className="navRow button-row">
                                        <SendButton onClick={() => sendFormData(sendEinreichungMail)} />
                                    </div>
                                </>
                                }
                            </div>

                            <div className="chatBox">
                                {/* Your chat box components */}
                                {form == 1 &&
                                    <>
                                    <ChatBox timer_value={1000}>Zuerst benötige ich Daten zu deinem Wohnprojekt und deinen Eigenmitteln, um den Umfang und die Gesamtkosten beurteilen zu können.</ChatBox>
                                    {(zweck == "11" || zweck == "12") && (<ChatBox timer_value={2000}>Alles klar! Du möchtest einen bestehenden Kredit umschulden! Bitte gib den geschätzten Verkehrswert ein. Auf die Details zu deinem bestehenden Kredit komme ich später zurück.</ChatBox>)}
                                    </>
                                }
                                {form == 2 &&
                                    <>
                                    <ChatBox timer_value={1000}>Als nächstes widmen wir uns persönlichen Daten; ich benötige personenbezogene Daten um eine Risikoanalyse deiner Situation durchführen zu können. Ebenso ist es wichtig deine finanzielle Situation zu kennen, um einschätzen zu können welche Rate du dir leisten kannst.</ChatBox>
                                    <ChatBox timer_value={5000}>Wenn du noch eine zweite Person zu deinem Kreditantrag hinzufügen möchtest, um etwa durch mehrere Einkommen den möglichen Kreditbetrag zu erhöhen, weil der Kauf gemeinsam erfolgt oder es mehrere Eigentümer*innen gibt, klicke auf den Button „zweite Person hinzufügen“ unten!</ChatBox>
                                    </>
                                }
                                {form == 3 &&
                                <ChatBox timer_value={1000}>Nun muss ich wissen, ob du bereits bestehende Vorlasten hast. Das kann zum Beispiel ein Kredit, eine Förderung, ein Kauf auf Ratenzahlung oder auch ein Leasing sein. Du kannst mit dem Button „Vorbelastung hinzufügen“ unten bis zu drei Vorlasten zu deinem Projekt hinzufügen.</ChatBox>}
                                {form == 4 &&
                                <ChatBox timer_value={1000}>Gleich geschafft! Gib hier bitte noch deine gewünschte Kreditlaufzeit ein. Und wenn du möchtest auch einen tilgungsfreien Zeitraum, in dem du noch keine Kreditrate zahlen möchtest (wenn der Kauf und die Aufgabe der alten Wohnung sich z.B.überschneiden)
                                Wenn du Fragen zum Datenschutz hast, kannst du gerne hier nachsehen.
                                </ChatBox>}
                                {form == 5 &&
                                <ChatBox timer_value={1000}>
                                    {products.length == 0 && <><b>OH JE,</b><br/>
                                    leider geht sich dein gewünschter Kredit nicht aus! Wir können nun noch die nebenstehenden Möglichkeiten prüfen.</>}
                                    {products.length > 0 && <>Super!
                                    Ich habe für dich passende Produkte unterschiedlicher österreichischer Banken und Bausparkassen ausgewählt, die genau zu deinem Projekt passen! Wähle nun bitte ein Produkt aus!</>}</ChatBox>}
                                {form == 6 &&
                                <ChatBox timer_value={1000}>Bitte teile mir zur Abschluss noch mit, wie mein Team dich erreichen kann. Dann kommen wir in den nächsten 2 Geschäftstagen mit dem weiteren Vorgehen für deinen Wohnkredit auf dich zu!
                                </ChatBox>}
                                {shownChats.map((chat, index) => (
                                    <ChatBox key={index}>
                                        {chat.message}
                                    </ChatBox>
                                ))}
                                <p class="chat-text chat-text-right">
                                    <br/>
                                    <a href="#finley" class="chat-text-right-a">Alles klar, befüllen wir das Feld &rarr;</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <Login onLogin={handleLogin} />
            )}
        </>
    );
}
